<template>
  <div>
    <div class="nav nav-tabs nav-fill">
      <a
        v-for="(tab, index) in tabs"
        :key="index"
        class="nav-item nav-link"
        :class="[{active : tab.isActive }, tab.classCustom]"
        data-toggle="tab"
        :href="`#${tab.href}`"
        :aria-controls="tab.href"
        :aria-selected="tab.isActive"
      >{{ tab.title }}</a>
    </div>
    <div class="tab-content">
      <div
        v-for="(tab, index) in tabs"
        :key="index"
        class="tab-pane fade"
        :class="[{show: tab.isActive}, {active: tab.isActive}]"
        :id="tab.href"
        aria-labelledby="nav-home-tab"
      >
        <component
            :is="tab.component"
            :data="tab.data"
            :numbers="numbers"
            :isPowerBall="isPowerBall"
            :tabsMainMarket="tabsMainMarket"
            :tabsMoreMarket="tabsMoreMarket"
            :numbersMainBallSet="numbersMainBallSet"
            :numbersBonusBall="numbersBonusBall"
            :numbersPowerBallSet="numbersPowerBallSet"
            :listPayouts="listPayouts"
            :dataMoreMarkets="dataMoreMarkets"
            :listChosen="listChosen"
            :isShowModalConfirmDelete="isShowModalConfirmDelete"
            @clickItem="handleClickItemMoreMarket"
            @handleChosenItem="handleChosenNumber"
            @quickPick="handleQuickPick"
            @handleAddLine="$emit('handleAddLine')"
            @clickAddBetslip="$emit('clickAddBetslip')"
            @clickViewBetslip="$emit('clickViewBetslip')"
            @cancelDeleteItem="$emit('cancelDeleteItem')"
            @handleDeleteItemChosen="$emit('handleDeleteItemChosen')"
            @handleConfirmDeleteItemChosen="handleConfirmDeleteItemChosen"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataMoreMarkets: {
      type: Array,
      default: () => []
    },
    listPayouts: {
      type: Array,
      default: () => []
    },
    tabs: {
      type: Array,
      default: () => []
    },
    numbers: {
      type: Array,
      default: () => []
    },
    numbersMainBallSet: {
      type: Array,
      default: () => []
    },
    numbersPowerBallSet: {
      type: Array,
      default: () => []
    },
    numbersBonusBall: {
      type: Array,
      default: () => []
    },
    listChosen: {
      type: Array,
      default: () => []
    },
    isShowModalConfirmDelete: {
      type: Boolean,
      default: false
    },
    isPowerBall: {
      type: Boolean,
      default: false
    },
    tabsMainMarket: {
      type: Array,
      default: () => []
    },
    tabsMoreMarket: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    handleClickItemMoreMarket(value) {
      this.$emit('clickItem', value)
    },
    handleChosenNumber(index) {
      this.$emit('handleChosenItem', index)
    },
    handleConfirmDeleteItemChosen(index) {
      this.$emit('handleConfirmDeleteItemChosen', index)
    },
    handleQuickPick(number) {
      this.$emit('quickPick', number)
    }
  }
}
</script>
<style scoped lang="scss" src="@/assets/scss/common/tab/tab-swift.scss"/>
